import { useTranslation } from "react-i18next";
import { FiMail, FiPhone, FiArrowRight } from "react-icons/fi";
import contactBanner from "../assets/about-banner.jpg";

const Contact = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-light text-dark overflow-hidden">
      <div className="relative h-[420px] sm:h-[500px] md:h-[600px]">
        <img
          src={contactBanner}
          className="absolute inset-0 w-full h-full object-cover"
          alt="contactbanner"
        />
        <div className="absolute inset-0 bg-black/65" />

        <div className="relative z-10 h-full flex items-center justify-center text-center">
          <div className="container mx-auto px-6">
            <h1 className="text-3xl sm:text-5xl font-bold text-light">
              {t("contactHeroTitle")}
            </h1>

            <p className="mt-6 text-light/80 max-w-2xl mx-auto">
              {t("contactHeroDesc")}
            </p>
          </div>
        </div>
      </div>

      <div className="py-20">
        <div className="container mx-auto px-6 md:px-20 grid lg:grid-cols-2 gap-8">
          <a
            href="tel:+995599000000"
            className="group p-10 bg-gray-50 rounded-3xl hover:bg-green transition"
          >
            <FiPhone className="text-4xl mb-6 text-green group-hover:text-white" />

            <p className="text-sm uppercase text-gray-500 group-hover:text-white/70">
              {t("phoneLabel")}
            </p>

            <h2 className="text-xl md:text-3xl font-bold mt-3 group-hover:text-white">
              +995 599 00 00 00
            </h2>

            <div className="mt-8 flex items-center gap-2 text-green group-hover:text-white">
              <span>{t("callAction")}</span>
              <FiArrowRight />
            </div>
          </a>

          <a
            href="mailto:ecotransgeorgia@gmail.com"
            className="group p-10 bg-gray-50 rounded-3xl hover:bg-greenDark transition"
          >
            <FiMail className="text-4xl mb-6 text-green group-hover:text-white" />

            <p className="text-sm uppercase text-gray-500 group-hover:text-white/70">
              {t("emailLabel")}
            </p>

            <h2 className="text-xl md:text-2xl font-bold mt-3 break-all group-hover:text-white">
              ecotransgeorgia@gmail.com
            </h2>

            <div className="mt-8 flex items-center gap-2 text-green group-hover:text-white">
              <span>{t("messageAction")}</span>
              <FiArrowRight />
            </div>
          </a>
        </div>
      </div>

      <div className="bg-greenDark md:pb-20 md:bg-light md:px-20 md:container md:mx-auto">
        <div className="container mx-auto px-6 text-center flex flex-col items-center bg-greenDark md:rounded-3xl py-16">
          <h2 className="text-3xl md:text-5xl text-white font-bold max-w-800 text-center !leading-normal">
            {t("wasteServiceTitle")}
          </h2>

          <p className="mt-6 text-white/70 max-w-2xl mx-auto">
            {t("ecoSubText")}
          </p>

          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <span className="px-6 py-3 bg-white/10 text-white rounded-full">
              {t("fastService")}
            </span>

            <span className="px-6 py-3 bg-white/10 text-white rounded-full">
              {t("ecoFriendly")}
            </span>

            <span className="px-6 py-3 bg-white/10 text-white rounded-full">
              {t("professionalTeam")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
